import _ from 'lodash';
import { DateTime } from 'luxon';

export const formatNotary = (notary) => {
  const attributes = {};
  const relationships = {};
  const id = notary.id && notary.id !== 'dummy' ? notary.id : undefined;

  if (_.has(notary, 'nombre') && _.has(notary, 'apellidos')) {
    if (!_.isNil(notary.nombre) && !_.isNil(notary.apellidos)) {
      attributes.title = `${notary.nombre} ${notary.apellidos}`;
    } else if (!_.isNil(notary.nombre)) {
      attributes.title = `${notary.nombre}`;
    } else {
      attributes.title = `Notary - ${Date.now()}`;
    }
  } else {
    attributes.title = `Notary - ${Date.now()}`;
  }
  if (notary.nombre && notary.apellidos) {
    attributes.title = `${notary.nombre} ${notary.apellidos}`;
  }
  if (notary.nombre) {
    attributes.nt_nombre = notary.nombre;
  }
  if (notary.apellidos) {
    attributes.nt_apellidos = notary.apellidos;
  }
  if (notary.telefono) {
    attributes.nt_telefono = notary.telefono;
  }
  return {
    data: {
      id,
      type: 'node--notary',
      attributes,
      relationships,
    },
  };
};
export const formatOperationNotary = (operationModel) => {
  const relationships = {};
  if (operationModel.notaryModel) {
    relationships.notario_operacion = {
      data: {
        type: 'node--notary',
        id: operationModel.notaryModel.id,
      },
    };
  }
  return {
    data: {
      id: operationModel.op,
      type: 'node--operation',
      relationships,
    },
  };
};
export const formatDatesAssigments = (datesModel) => {
  const attributes = {};
  if (datesModel.notaryModel.fechaFirma) {
    attributes.f_firma_notario = DateTime.fromISO(datesModel.notaryModel.fechaFirma).setLocale('es').toFormat("yyyy-MM-dd'T'HH:mm:ss");
  }
  return {
    data: {
      id: datesModel.date,
      type: 'node--date_assignement',
      attributes,
    },
  };
};
export const processNotary = (notary) => {
  const { attributes, id, type } = notary;
  const notaryModel = { id, type };
  if ('title' in attributes) {
    notaryModel.title = attributes.title;
  }
  if ('nt_nombre' in attributes) {
    notaryModel.nombre = attributes.nt_nombre;
  }
  if ('nt_apellidos' in attributes) {
    notaryModel.apellidos = attributes.nt_apellidos;
  }
  if ('nt_telefono' in attributes) {
    notaryModel.telefono = attributes.nt_telefono;
  }
  return notaryModel;
};

export const processNotaryResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(notary =>
      processNotary(notary));
  }
  return processNotary(res.data.data);
};



// WEBPACK FOOTER //
// ./src/features/notary/utils.js